import styled from 'styled-components';
import React from 'react';
import PropTypes from 'prop-types';

const Spinner = ({ size = 15, color = '#777' }) => (
  <SpinnerStyle size={size} color={color}>
    <div className="bounce1" />
    <div className="bounce2" />
    <div className="bounce3" />
  </SpinnerStyle>
);

Spinner.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string
};

const SpinnerStyle = styled.div`
  margin: auto 0;
  width: 100%;
  text-align: center;

  & > div {
    width: ${props => props.size || 15}px;
    height: ${props => props.size || 15}px;
    margin: 0 ${props => props.size / 5 || 3}px;
    background-color: ${props => props.color || '#777'};
    border-radius: 100%;
    display: inline-block;
    -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  }

  & > .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }

  & > .bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }

  @-webkit-keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
    }
  }

  @keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
`;

const Loader = ({ size, style = {} }) => (
  <div style={{ display: 'flex', flexGrow: 1, alignItems: 'center', minHeight: 250, ...style }}>
    <Spinner size={size} />
  </div>
);

Loader.propTypes = {
  size: PropTypes.number,
  style: PropTypes.object
};

export default Loader;
